// src/shared-components/forms/add-board-content/add-article/published-article/RecommendedArticlesList.jsx
import { useNavigate } from 'react-router-dom';

import { NextButton,PrevButton } from "@/shared-components/buttons/components/SliderControls";
// 1) IMPORT FHSlider and Prev/Next buttons:
import FHSlider from "@/shared-components/sliders/components/FHSlider";
import Text from "@/shared-components/text/components/Text";
import { buildPublicContentPath, resolvePublicContentKind } from '@/utils/contentRoutes';

import BoardCard from "../../shared-components/BoardCard";

import "./RecommendedArticlesList.css";

export default function RecommendedArticlesList({ articles = [] }) {
  const navigate = useNavigate();

  if (!Array.isArray(articles) || articles.length === 0) {
    return null;
  }

  return (
    <div className="recommended-articles__wrapper">
      <Text className="recommended-articles__header font-size-large" semibold>
        Recommended articles
      </Text>
      {/**  
        2) REPLACE the vertical “list” div with FHSlider.
           Each child (BoardCard) now lives inside a .recommended-articles__item
           which will be treated as a “slide.”
      **/}
      <FHSlider
        speed={2}
        className="recommended-articles__slider"
        customPrevButton={<PrevButton />}
        customNextButton={<NextButton />}
      >
        {articles.map(article => {
          const target = buildPublicContentPath(article, resolvePublicContentKind(article));

          return (
            <div
              key={article._id}
              className="recommended-articles__item"
              onClick={e => {
                e.stopPropagation();
                navigate(target, { state: { from: true } });
              }}
            >
              <BoardCard data={article} />
            </div>
          );
        })}
      </FHSlider>
    </div>
  );
}
